import { RouteDetail } from '../types/sms';
import { RecentOrSuggestedSearchEntry } from '../types/RenderTypes';

export const mapRouteDetailToRecentSearch = (item: RouteDetail) : RecentOrSuggestedSearchEntry => ({
  ports: item.ports,
  routeId: item.routeId,
  iconName: '',
  textCode: item.textCode,
});
